export type Country = {
  code: string;
  name: string;
};

export const countries: Record<string, Country> = {
  ['united kingdom']: { code: 'GBR', name: 'United Kingdom' },
  ['uk']: { code: 'GBR', name: 'United Kingdom' },
  ['england']: { code: 'GBR', name: 'England' },
  ['scotland']: { code: 'GBR', name: 'Scotland' },
  ['wales']: { code: 'GBR', name: 'Wales' },
  ['northern ireland']: { code: 'GBR', name: 'Northern Ireland' },
  ['isle of man']: { code: 'IMN', name: 'Isle of Man' },
  ['channel islands']: { code: 'GBR', name: 'Channel Islands' },
  ['afghanistan']: { code: 'AFG', name: 'Afghanistan' },
  ['albania']: { code: 'ALB', name: 'Albania' },
  ['algeria']: { code: 'DZA', name: 'Algeria' },
  ['andorra']: { code: 'AND', name: 'Andorra' },
  ['angola']: { code: 'AGO', name: 'Angola' },
  ['antigua and barbuda']: { code: 'ATG', name: 'Antigua and Barbuda' },
  ['argentina']: { code: 'ARG', name: 'Argentina' },
  ['armenia']: { code: 'ARM', name: 'Armenia' },
  ['australia']: { code: 'AUS', name: 'Australia' },
  ['austria']: { code: 'AUT', name: 'Austria' },
  ['azerbaijan']: { code: 'AZE', name: 'Azerbaijan' },
  ['bahamas']: { code: 'BHS', name: 'Bahamas' },
  ['bahrain']: { code: 'BHR', name: 'Bahrain' },
  ['bangladesh']: { code: 'BGD', name: 'Bangladesh' },
  ['barbados']: { code: 'BRB', name: 'Barbados' },
  ['belarus']: { code: 'BLR', name: 'Belarus' },
  ['belgium']: { code: 'BEL', name: 'Belgium' },
  ['belize']: { code: 'BLZ', name: 'Belize' },
  ['benin']: { code: 'BEN', name: 'Benin' },
  ['bhutan']: { code: 'BTN', name: 'Bhutan' },
  ['bolivia']: { code: 'BOL', name: 'Bolivia' },
  ['bosnia and herzegovina']: { code: 'BIH', name: 'Bosnia and Herzegovina' },
  ['botswana']: { code: 'BWA', name: 'Botswana' },
  ['brazil']: { code: 'BRA', name: 'Brazil' },
  ['brunei']: { code: 'BRN', name: 'Brunei' },
  ['bulgaria']: { code: 'BGR', name: 'Bulgaria' },
  ['burkina faso']: { code: 'BFA', name: 'Burkina Faso' },
  ['burundi']: { code: 'BDI', name: 'Burundi' },
  ['cabo verde']: { code: 'CPV', name: 'Cabo Verde' },
  ['cambodia']: { code: 'KHM', name: 'Cambodia' },
  ['cameroon']: { code: 'CMR', name: 'Cameroon' },
  ['canada']: { code: 'CAN', name: 'Canada' },
  ['central african republic']: { code: 'CAF', name: 'Central African Republic' },
  ['chad']: { code: 'TCD', name: 'Chad' },
  ['chile']: { code: 'CHL', name: 'Chile' },
  ['china']: { code: 'CHN', name: 'China' },
  ['colombia']: { code: 'COL', name: 'Colombia' },
  ['comoros']: { code: 'COM', name: 'Comoros' },
  ['congo (congo-brazzaville)']: { code: 'COG', name: 'Congo (Congo-Brazzaville)' },
  ['costa rica']: { code: 'CRI', name: 'Costa Rica' },
  ['croatia']: { code: 'HRV', name: 'Croatia' },
  ['cuba']: { code: 'CUB', name: 'Cuba' },
  ['cyprus']: { code: 'CYP', name: 'Cyprus' },
  ['czechia']: { code: 'CZE', name: 'Czechia' },
  ['denmark']: { code: 'DNK', name: 'Denmark' },
  ['djibouti']: { code: 'DJI', name: 'Djibouti' },
  ['dominica']: { code: 'DMA', name: 'Dominica' },
  ['dominican republic']: { code: 'DOM', name: 'Dominican Republic' },
  ['ecuador']: { code: 'ECU', name: 'Ecuador' },
  ['egypt']: { code: 'EGY', name: 'Egypt' },
  ['el salvador']: { code: 'SLV', name: 'El Salvador' },
  ['equatorial guinea']: { code: 'GNQ', name: 'Equatorial Guinea' },
  ['eritrea']: { code: 'ERI', name: 'Eritrea' },
  ['estonia']: { code: 'EST', name: 'Estonia' },
  ['eswatini']: { code: 'SWZ', name: 'Eswatini' },
  ['ethiopia']: { code: 'ETH', name: 'Ethiopia' },
  ['fiji']: { code: 'FJI', name: 'Fiji' },
  ['finland']: { code: 'FIN', name: 'Finland' },
  ['france']: { code: 'FRA', name: 'France' },
  ['gabon']: { code: 'GAB', name: 'Gabon' },
  ['gambia']: { code: 'GMB', name: 'Gambia' },
  ['georgia']: { code: 'GEO', name: 'Georgia' },
  ['germany']: { code: 'DEU', name: 'Germany' },
  ['ghana']: { code: 'GHA', name: 'Ghana' },
  ['greece']: { code: 'GRC', name: 'Greece' },
  ['grenada']: { code: 'GRD', name: 'Grenada' },
  ['guatemala']: { code: 'GTM', name: 'Guatemala' },
  ['guinea']: { code: 'GIN', name: 'Guinea' },
  ['guinea-bissau']: { code: 'GNB', name: 'Guinea-Bissau' },
  ['guyana']: { code: 'GUY', name: 'Guyana' },
  ['haiti']: { code: 'HTI', name: 'Haiti' },
  ['honduras']: { code: 'HND', name: 'Honduras' },
  ['hungary']: { code: 'HUN', name: 'Hungary' },
  ['iceland']: { code: 'ISL', name: 'Iceland' },
  ['india']: { code: 'IND', name: 'India' },
  ['indonesia']: { code: 'IDN', name: 'Indonesia' },
  ['iran']: { code: 'IRN', name: 'Iran' },
  ['iraq']: { code: 'IRQ', name: 'Iraq' },
  ['ireland']: { code: 'IRL', name: 'Ireland' },
  ['israel']: { code: 'ISR', name: 'Israel' },
  ['italy']: { code: 'ITA', name: 'Italy' },
  ['jamaica']: { code: 'JAM', name: 'Jamaica' },
  ['japan']: { code: 'JPN', name: 'Japan' },
  ['jordan']: { code: 'JOR', name: 'Jordan' },
  ['kazakhstan']: { code: 'KAZ', name: 'Kazakhstan' },
  ['kenya']: { code: 'KEN', name: 'Kenya' },
  ['kiribati']: { code: 'KIR', name: 'Kiribati' },
  ['kuwait']: { code: 'KWT', name: 'Kuwait' },
  ['kyrgyzstan']: { code: 'KGZ', name: 'Kyrgyzstan' },
  ['laos']: { code: 'LAO', name: 'Laos' },
  ['latvia']: { code: 'LVA', name: 'Latvia' },
  ['lebanon']: { code: 'LBN', name: 'Lebanon' },
  ['lesotho']: { code: 'LSO', name: 'Lesotho' },
  ['liberia']: { code: 'LBR', name: 'Liberia' },
  ['libya']: { code: 'LBY', name: 'Libya' },
  ['liechtenstein']: { code: 'LIE', name: 'Liechtenstein' },
  ['lithuania']: { code: 'LTU', name: 'Lithuania' },
  ['luxembourg']: { code: 'LUX', name: 'Luxembourg' },
  ['madagascar']: { code: 'MDG', name: 'Madagascar' },
  ['malawi']: { code: 'MWI', name: 'Malawi' },
  ['malaysia']: { code: 'MYS', name: 'Malaysia' },
  ['maldives']: { code: 'MDV', name: 'Maldives' },
  ['mali']: { code: 'MLI', name: 'Mali' },
  ['malta']: { code: 'MLT', name: 'Malta' },
  ['mexico']: { code: 'MEX', name: 'Mexico' },
  ['moldova']: { code: 'MDA', name: 'Moldova' },
  ['monaco']: { code: 'MCO', name: 'Monaco' },
  ['mongolia']: { code: 'MNG', name: 'Mongolia' },
  ['montenegro']: { code: 'MNE', name: 'Montenegro' },
  ['morocco']: { code: 'MAR', name: 'Morocco' },
  ['mozambique']: { code: 'MOZ', name: 'Mozambique' },
  ['myanmar']: { code: 'MMR', name: 'Myanmar' },
  ['namibia']: { code: 'NAM', name: 'Namibia' },
  ['nauru']: { code: 'NRU', name: 'Nauru' },
  ['nepal']: { code: 'NPL', name: 'Nepal' },
  ['netherlands']: { code: 'NLD', name: 'Netherlands' },
  ['new zealand']: { code: 'NZL', name: 'New Zealand' },
  ['nicaragua']: { code: 'NIC', name: 'Nicaragua' },
  ['niger']: { code: 'NER', name: 'Niger' },
  ['nigeria']: { code: 'NGA', name: 'Nigeria' },
  ['norway']: { code: 'NOR', name: 'Norway' },
  ['oman']: { code: 'OMN', name: 'Oman' },
  ['pakistan']: { code: 'PAK', name: 'Pakistan' },
  ['palau']: { code: 'PLW', name: 'Palau' },
  ['panama']: { code: 'PAN', name: 'Panama' },
  ['papua new guinea']: { code: 'PNG', name: 'Papua New Guinea' },
  ['paraguay']: { code: 'PRY', name: 'Paraguay' },
  ['peru']: { code: 'PER', name: 'Peru' },
  ['philippines']: { code: 'PHL', name: 'Philippines' },
  ['poland']: { code: 'POL', name: 'Poland' },
  ['portugal']: { code: 'PRT', name: 'Portugal' },
  ['qatar']: { code: 'QAT', name: 'Qatar' },
  ['romania']: { code: 'ROU', name: 'Romania' },
  ['russia']: { code: 'RUS', name: 'Russia' },
  ['rwanda']: { code: 'RWA', name: 'Rwanda' },
  ['saint kitts and nevis']: { code: 'KNA', name: 'Saint Kitts and Nevis' },
  ['saint lucia']: { code: 'LCA', name: 'Saint Lucia' },
  ['saint vincent and the grenadines']: { code: 'VCT', name: 'Saint Vincent and the Grenadines' },
  ['samoa']: { code: 'WSM', name: 'Samoa' },
  ['san marino']: { code: 'SMR', name: 'San Marino' },
  ['sao tome and principe']: { code: 'STP', name: 'Sao Tome and Principe' },
  ['saudi arabia']: { code: 'SAU', name: 'Saudi Arabia' },
  ['senegal']: { code: 'SEN', name: 'Senegal' },
  ['serbia']: { code: 'SRB', name: 'Serbia' },
  ['seychelles']: { code: 'SYC', name: 'Seychelles' },
  ['sierra leone']: { code: 'SLE', name: 'Sierra Leone' },
  ['singapore']: { code: 'SGP', name: 'Singapore' },
  ['slovakia']: { code: 'SVK', name: 'Slovakia' },
  ['slovenia']: { code: 'SVN', name: 'Slovenia' },
  ['solomon islands']: { code: 'SLB', name: 'Solomon Islands' },
  ['somalia']: { code: 'SOM', name: 'Somalia' },
  ['south africa']: { code: 'ZAF', name: 'South Africa' },
  ['south sudan']: { code: 'SSD', name: 'South Sudan' },
  ['spain']: { code: 'ESP', name: 'Spain' },
  ['sri lanka']: { code: 'LKA', name: 'Sri Lanka' },
  ['sudan']: { code: 'SDN', name: 'Sudan' },
  ['suriname']: { code: 'SUR', name: 'Suriname' },
  ['sweden']: { code: 'SWE', name: 'Sweden' },
  ['switzerland']: { code: 'CHE', name: 'Switzerland' },
  ['syria']: { code: 'SYR', name: 'Syria' },
  ['taiwan']: { code: 'TWN', name: 'Taiwan' },
  ['tajikistan']: { code: 'TJK', name: 'Tajikistan' },
  ['tanzania']: { code: 'TZA', name: 'Tanzania' },
  ['thailand']: { code: 'THA', name: 'Thailand' },
  ['timor-leste']: { code: 'TLS', name: 'Timor-Leste' },
  ['togo']: { code: 'TGO', name: 'Togo' },
  ['tonga']: { code: 'TON', name: 'Tonga' },
  ['trinidad and tobago']: { code: 'TTO', name: 'Trinidad and Tobago' },
  ['tunisia']: { code: 'TUN', name: 'Tunisia' },
  ['turkey']: { code: 'TUR', name: 'Turkey' },
  ['turkmenistan']: { code: 'TKM', name: 'Turkmenistan' },
  ['tuvalu']: { code: 'TUV', name: 'Tuvalu' },
  ['uganda']: { code: 'UGA', name: 'Uganda' },
  ['ukraine']: { code: 'UKR', name: 'Ukraine' },
  ['united arab emirates']: { code: 'ARE', name: 'United Arab Emirates' },
  ['united states of america']: { code: 'USA', name: 'United States of America' },
  ['uruguay']: { code: 'URY', name: 'Uruguay' },
  ['uzbekistan']: { code: 'UZB', name: 'Uzbekistan' },
  ['vanuatu']: { code: 'VUT', name: 'Vanuatu' },
  ['vatican city']: { code: 'VAT', name: 'Vatican City' },
  ['venezuela']: { code: 'VEN', name: 'Venezuela' },
  ['vietnam']: { code: 'VNM', name: 'Vietnam' },
  ['yemen']: { code: 'YEM', name: 'Yemen' },
  ['zambia']: { code: 'ZMB', name: 'Zambia' },
  ['zimbabwe']: { code: 'ZWE', name: 'Zimbabwe' },
};
